export default {
  version: "2021.01.21 @ " + process.env.VUE_APP_TITLE,
  useConfigUrl: process.env.VUE_APP_STATIC_URL == "true",
  baseUrl: process.env.VUE_APP_BASE_URL,
  r1Url: process.env.VUE_APP_R1_URL,
  r2Url: process.env.VUE_APP_R2_URL,
  r3Url: process.env.VUE_APP_R3_URL,

  live22Path: process.env.VUE_APP_LIVE22_DETAIL_URL,
  kkPath: process.env.VUE_APP_KK_DETAIL_URL,
  nkPath: process.env.VUE_APP_NK_DETAIL_URL,
  uuPath: process.env.VUE_APP_UU_DETAIL_URL,

  userBaseUrl: "/api",
  accessRoles: {
    adminAccount: "admin_account",
    account: "account",
    report: "report",
    subAccount: "sub_account",
    editAccount: "edit_account",
    editLimit: "edit_limit",
    editIp: "edit_ip",
    editOperatorLimit: "operator_limit",
    stock: "stock",
    log: "log",
    messages: "messages",
    promotion: "promotion",
    settlement: "settlement",
    ticket: "ticket",
    walletLog: "wallet_log",
    providerLog: "provider_log",
    settlementScheduleLog: "settlement_schedule_log",
    settlementHistoryDownline: "settlement_history_downline",
    bank: "bank",
    socialAccount: "social_account"
  },
  getDomain(url, subdomain) {
    subdomain = subdomain || false;

    url = url.replace(/(https?:\/\/)?(www.)?/i, "");

    if (!subdomain) {
      url = url.split(".");

      url = url.slice(url.length - 2).join(".");
    }

    if (url.indexOf("/") !== -1) {
      return url.split("/")[0];
    }

    return url;
  },
  getBaseUrl() {
    if (this.useConfigUrl) {
      return this.baseUrl;
    }
    var domain = this.getDomain(window.location.hostname, false);
    if (domain != "localhost") {
      return "https://api." + domain;
    } else {
      return this.baseUrl;
    }
  },
  oddsType: {
    1: "MY",
    2: "HK",
    3: "ID",
    4: "DEC"
  },
  loginUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/account/login";
  },
  securityValidateUrl(){
    return this.getBaseUrl() + this.userBaseUrl + "/account/security_validate";
  },
  securityDisableUrl(){
    return this.getBaseUrl() + this.userBaseUrl + "/account/security_disable";
  },
  securityUpdateUrl(){
    return this.getBaseUrl() + this.userBaseUrl + "/account/security_update";
  },
  secAccountFullUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/account/account_add_sec";
  },
  getSubAccountListUrl(){
    return this.getBaseUrl() + this.userBaseUrl + "/account/sub/list";
  },
  addSubAccountUrl(){
    return this.getBaseUrl() + this.userBaseUrl + "/account/sub/add";
  },
  subAccountBlockUrl(){
    return this.getBaseUrl() + this.userBaseUrl + "/account/sub/block";
  },
  subAccountUnblockUrl(){
    return this.getBaseUrl() + this.userBaseUrl + "/account/sub/unblock";
  },
  getSubAccountDetailsUrl(){
    return this.getBaseUrl() + this.userBaseUrl + "/account/sub/detail";
  },
  updateAuthorityUrl(){
    return this.getBaseUrl() + this.userBaseUrl + "/account/sub/edit";
  },
  resetPasswordSubUrl(){
    return this.getBaseUrl() + this.userBaseUrl + "/account/sub/password_reset";
  },
  resetPasswordAdminUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/account/admin/password_reset";
  },
  updateStatusAdminUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/account/admin/status_update";
  },
  addAdminUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/account/admin/add";
  },
  getAdminListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/account/admin/list";
  },
  addShareholderUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/account/add_sh";
  },
  addAccountUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/account/add";
  },
  resetPasswordUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/account/password_reset";
  },
  updatePasswordUrl(){
    return this.getBaseUrl() + this.userBaseUrl + "/account/password_update";
  },
  resetPasswordPostUrl(){
    return this.getBaseUrl() + this.userBaseUrl + "/account/password_update_after_reset";
  },
  unblockProfileUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/account/unblock";
  },
  updateStatusUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/account/status_update";
  },
  getAccountListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/account/list";
  },
  getAccountDetailsUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/account/detail";
  },
  getAccountOverviewUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/account/overview";
  },
  getAccountLookupUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/account/lookup";
  },
  updateAccountDetailsUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/account/edit";
  },
  resetWinUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/account/accumulate_win_reset";
  },
  getBetLimitUrl(){
    return this.getBaseUrl() + this.userBaseUrl + "/account/bet_limit_get";
  },
  updateBetLimitLCUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/account/bet_limit_update_livecasino";
  },
  updateBetLimitSBUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/account/bet_limit_update_sportsbook";
  },
  getPositionTakingUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/account/position_get";
  },
  updatePositionTakingLCUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/account/position_update_livecasino";
  },
  updatePositionTakingSLUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/account/position_update_slots";
  },
  updatePositionTakingSB1Url() {
    return this.getBaseUrl() + this.userBaseUrl + "/account/position_update_sportsbook";
  },
  updatePositionTakingMMOUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/account/position_update_sportsbook_mmo";
  },
  getCommissionUrl(){
    return this.getBaseUrl() + this.userBaseUrl + "/account/commission_get";
  },
  updateCommissionLCUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/account/commission_update_livecasino";
  },
  updateCommissionSLUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/account/commission_update_slots";
  },
  updateCommissionSBUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/account/commission_update_sportsbook";
  },
  updateCommissionMMOUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/account/commission_update_sportsbook_mmo";
  },
  getScheduleUrl(){
    return this.getBaseUrl() + this.userBaseUrl + "/account/schedule_get";
  },
  getDailyWinloseUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/report/daily_winlose";
  },
  getDailyStatementUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/report/daily_statement";
  },
  getGameResultSportsbookUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/report/game_result_sportsbook";
  },
  getGameResultSlotsUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/report/game_result_slots";
  },
  getGameResultLivecasinoUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/report/game_result_livecasino";
  },
  getGameResultLivecasinoDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/report/game_result_livecasino_detail";
  },
  getGameResultChangesUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/report/game_result_changes";
  },
  getPlatformWinloseUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/report/platform_winlose";
  },
  transferCashUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/transfer_cash";
  },
  settlementCashUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/settlement_cash";
  },
  settlementCreditUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/settlement_credit";
  },
  getSettlementHistoryUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/settlement_history";
  },
  getSettlementHistoryDownlineUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/settlement_history_downline";
  },
  getSettlementListCashUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/settlement_list_cash";
  },
  getSettlementListCreditUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/settlement_list_credit";
  },
  settlementEligibilityUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/settlement_eligibility";
  },
  getWalletUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/wallet_get";
  },
  currencyLookupUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/currency_lookup";
  },
  getPromotionListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotion_list";
  },
  addPromotionUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotion_add";
  },
  updatePromotionStatusUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotion_status_update";
  },
  getProviderUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/provider_get";
  },
  providerLookupUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/provider_lookup";
  },
  providerWinloseUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/provider_winlose";
  },
  updateProviderUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/provider_update";
  },
  getTicketListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticket_list";
  },
  processTicketUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticket_process";
  },
  accessLogUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/log/audit_login_agent";
  },
  getMemberLogUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/log/audit_login_member";
  },
  accountLogUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/log/audit_account";
  },
  positionTakingSportsbookLogUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/log/audit_position_sportsbook";
  },
  positionTakingLivecasinoLogUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/log/audit_position_livecasino";
  },
  positionTakingSlotsLogUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/log/audit_position_slots";
  },
  betLimitSportsbookLogUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/log/audit_bet_limit_sportsbook";
  },
  betLimitLivecasinoLogUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/log/audit_bet_limit_livecasino";
  },
  commissionSportsbookLogUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/log/audit_commission_sportsbook";
  },
  commissionSportsbookMMOLogUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/log/audit_commission_sportsbook_mmo";
  },
  commissionLivecasinoLogUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/log/audit_commission_livecasino";
  },
  commissionSlotsLogUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/log/audit_commission_slots";
  },
  promotionLogUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/log/audit_promotion";
  },
  providerLogUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/log/audit_provider";
  },
  settlementScheduleLogUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/log/audit_settlement_schedule";
  },
  walletLogUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/log/audit_wallet";
  },
  checkDirectDownlineUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/account_check_direct_downline";
  },
  checkDownlineUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/account_check";
  },
  checkDownlineExistUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/account_check_exists";
  },
  checkAccountReservedUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/account_check_reserved";
  },
  getPlatformLookUpUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/platform_lookup";
  },
  getDailyWinloseAIOUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/report/daily_winlose_aio";
  },
  getDashboardInfoUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/dashboard";
  },
  getDomainInfoUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/info";
  },
  bankAccountGetUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/etc/bank_account_get";
  },
  bankAccountUpsertUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/etc/bank_account_upsert";
  },
  accountSocialGetUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/etc/account_social_get";
  },
  accountSocialUpsertUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/etc/account_social_upsert";
  },
  r1ResultUrl() {
    // All casino
    return this.r1Url + "/result?";
  },
  r2ResultUrl() {
    // GamingSoft
    return this.r2Url + "/result?bet_id=";
  },
  r3ResultUrl() {
    // Live22
    return this.r3Url + "/result?bet_id=";
  },
};
